import { render } from "./EditLocation.vue?vue&type=template&id=3b44fcd4&ts=true"
import script from "./EditLocation.vue?vue&type=script&lang=ts"
export * from "./EditLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__